import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { Crown, X } from "lucide-react";
import { API } from "../constants";
import { useAuth } from "../context/AuthContext";

const VIPSuccessPage = () => {
  const location = useLocation();
  const { token, refreshUser } = useAuth();
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sessionId = params.get('session_id');
    if (sessionId) {
      const checkStatus = async () => {
        try {
          const response = await axios.get(`${API}/vip/status/${sessionId}`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          if (response.data.payment_status === 'paid') {
            setStatus('success');
            await refreshUser();
          } else {
            setStatus('pending');
          }
        } catch (error) {
          setStatus('error');
        }
      };
      checkStatus();
      const interval = setInterval(checkStatus, 2000);
      setTimeout(() => clearInterval(interval), 30000);
      return () => clearInterval(interval);
    }
  }, [location, token, refreshUser]);

  return (
    <div className="min-h-screen bg-[#050505] pt-24 flex items-center justify-center">
      <div className="text-center max-w-md mx-auto px-4" data-testid="vip-success">
        {status === 'checking' && (
          <>
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-[#D4AF37] mx-auto mb-6"></div>
            <h1 className="font-heading text-3xl mb-4">Activating VIP...</h1>
            <p className="text-gray-400">Please wait while we activate your membership.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-20 h-20 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-6">
              <Crown className="w-10 h-10 text-black" />
            </div>
            <h1 className="font-heading text-3xl gold-text mb-4">Welcome to VIP!</h1>
            <p className="text-gray-400 mb-8">Your VIP membership is now active. Enjoy all the exclusive benefits!</p>
            <Link to="/university" className="bg-[#D4AF37] hover:bg-[#B5952F] text-black px-8 py-3 rounded-sm font-bold uppercase tracking-wider">Start Learning</Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-20 h-20 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <X className="w-10 h-10 text-white" />
            </div>
            <h1 className="font-heading text-3xl mb-4">Activation Failed</h1>
            <p className="text-gray-400 mb-8">Something went wrong. Please try again.</p>
            <Link to="/vip" className="bg-[#D62828] hover:bg-[#B91C1C] text-white px-8 py-3 rounded-sm font-bold uppercase tracking-wider">Try Again</Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VIPSuccessPage;
